import { ClassMemberWithDetails } from "@/graphql/schema";
import { FlexRowAlignCenter } from "@/components/Flex";
import UserAvatar from "@/components/userCardComponents/UserAvatar";

const StudentInformationCell = ({ member }: { member: ClassMemberWithDetails | null | undefined }) => {
    if (!member) return null;

    return (
        <FlexRowAlignCenter style={{ gap: "1.1rem", width: "15rem" }}>
            <UserAvatar radius={"4.4rem"} src={member.pictureUrl} />
            <div
                style={{ maxWidth: "90%" }}
                data-testid="auto-id-d11eefa6-f91d-40b2-9476-77bb48335816">
                <p
                    className="bodyBold2 ellipsisText"
                    data-testid="auto-id-c16ac72a-0e68-424f-8aa1-eb32e342ff6c">{member.Name}</p>
                <p
                    className="ellipsisText"
                    data-testid="auto-id-945d9eb2-7551-46b0-9710-1505b87ca993">@{member.username}</p>
            </div>
        </FlexRowAlignCenter>
    );
};

export default StudentInformationCell;
